const menuItems = [
  {
    label: "Home",
    key: "home",
    path: "https://www.zuresmile.com/",
  },
  {
    label: "About",
    key: "About",
    path: "https://www.zuresmile.com/about-us",
  },
  {
    label: "Benefits",
    key: "Benefits",
    path: "https://www.zuresmile.com/benefits",
  },
  {
    label: "Blog",
    key: "Blog",
    path: "https://www.zuresmile.com/blog",
  },
  {
    label: "Testimonials",
    key: "testimonial",
    path: "https://www.zuresmile.com/testimonials",
  },
  {
    label: "Contact",
    key: "contact",
    path: "https://www.zuresmile.com/contact-us",
  },
];

export default menuItems;
